export const EventStatuses = {
  ENABLED: "enabled",
  CANCELLED: "cancelled",
  DELETED: "deleted"
};
